var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CptCodesDataTable',{attrs:{"codes":_vm.cptCodes,"items-per-page":500}})
}
var staticRenderFns = []

export { render, staticRenderFns }